// ProfileTab.jsx
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';

import Tabs from '../component/Tabs.jsx';
import Tab from '../component/Tab.jsx';

import { PROFILE_TABS, ProfileListType } from '../resource/profileConstants.js';
import trackMixpanel, {
  EventTypes,
  getViewId,
  ButtonId,
} from '../resource/mixpanel.js';

import { color, textColor, headerHeight } from '../style/variables.js';
import media from '../style/media.js';

const tabObject = {
  [ProfileListType.STORY]: {
    titleI18nKey: 'broadcast',
    mixpanelButtonId: ButtonId.Profile.ButtonProfileStory,
  },
  [ProfileListType.SHORT]: {
    titleI18nKey: 'profile_shorts',
    mixpanelButtonId: ButtonId.Profile.ButtonProfileShorts,
  },
  [ProfileListType.FLIX]: {
    titleI18nKey: 'title_flix',
    mixpanelButtonId: ButtonId.Profile.ButtonProfileVideo,
  },
  [ProfileListType.IMAGE]: {
    titleI18nKey: 'profile_photo',
    mixpanelButtonId: ButtonId.Profile.ButtonProfileImage,
  },
  [ProfileListType.LIVESTREAM_SESSION]: {
    titleI18nKey: 'LIVE',
    mixpanelButtonId: ButtonId.Profile.ButtonProfileLive,
  },
};

const tabStyle = {
  opacity: 1,
};

export const ProfileTab = ({
  userId,
  profileTabs,
  isMeProfile,
  listType,
  t,
  replace,
}) => {
  const tabsList = profileTabs ? profileTabs.split(' ') : PROFILE_TABS;
  const tabs = tabsList
    .filter(tabId =>
      isMeProfile ? true : ProfileListType.LIVESTREAM_SESSION !== tabId
    )
    .filter(tabId => tabId);

  const handleTabChange = useCallback(
    (event, value) => {
      trackMixpanel({
        type: EventTypes.USER_CLICKED,
        payload: {
          viewId: getViewId({
            pathname: window.location.pathname,
          }),
          buttonId: tabObject[value]?.mixpanelButtonId,
        },
      });
      const url = new URL(location.href);
      ['_feed', '_filters', '_sorts'].forEach(key =>
        url.searchParams.delete(key)
      );
      if (tabs[0] === value) {
        return replace({
          pathname: `${`/user/${userId}`}${url.search}`,
        });
      }
      return replace({
        pathname: `${`/user/${userId}`}/${value}${url.search}`,
      });
    },
    [userId, tabs, replace]
  );
  return (
    <StyledProfileTab>
      <Tabs value={listType} onChange={handleTabChange}>
        {tabs.map(tabId => {
          const isActive = tabId === listType;
          return (
            <Tab
              key={tabId}
              value={tabId}
              labelStyle={tabStyle}
              label={
                <TabText isActive={isActive}>
                  {t(tabObject[tabId]?.titleI18nKey)}
                </TabText>
              }
            />
          );
        })}
      </Tabs>
    </StyledProfileTab>
  );
};

ProfileTab.propTypes = {
  userId: PropTypes.string,
  profileTabs: PropTypes.string,
  listType: PropTypes.string,
  isMeProfile: PropTypes.bool,
  t: PropTypes.func.isRequired,
  replace: PropTypes.func,
};

ProfileTab.defaultProps = {
  userId: null,
  profileTabs: '',
  listType: null,
  isMeProfile: false,
  replace: () => null,
};

const StyledProfileTab = styled.div`
  position: sticky;
  top: ${headerHeight}px;
  left: 0px;
  right: 0px;
  z-index: 2;
  border-bottom: 1px solid rgba(100, 100, 100, 0.15);
  background-color: ${color.black};
`;

const TabText = styled.h2.attrs(({ isActive }) => ({
  style: {
    opacity: 1,
    color: isActive ? textColor.white : textColor.black,
  },
}))`
  font-size: 16px;
  margin: 0;
  font-weight: normal;
  ${media.mobile`
    font-size: 14px;
  `};
`;

export default withTranslation()(ProfileTab);
